module.exports = __webpack_public_path__ + "img/locations.d178e2d0.svg";